import React, { Component } from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import CardSection from "./components/cardsection/CardSection";
import ChartSection from "./components/chartsection/ChartSection";
import Navbar from "./components/navbar/Navbar";
export default class App extends Component {
  constructor() {
    super();
    this.state = {
      Id: "Bitcoin",
      Data: {},
    };
  }
  fetchData = async () => {
    let data = await fetch("https://api.coingecko.com/api/v3/coins/" + this.state.Id);
    let JsonData = await data.json();
    this.setState({ Id: this.state.Id, Data: JsonData });
  };
  handleSubmit = async (event) => {
    await this.setState({Id: event.target.value,Data:this.state.Data})
    this.fetchData()
  }
  componentDidMount() {
    this.fetchData();
  }
  render() {
    return (
      <div>
        <Navbar handle_Submit = {this.handleSubmit}/>
        {/* here we created props variables */}
        <CardSection
          coinName={this.state.Data.name}
          currentPrice={
            this.state.Data.market_data
              ? this.state.Data.market_data.current_price["usd"]
              : ""
          }
          mCap24={
            this.state.Data.market_data
              ? this.state.Data.market_data.market_cap_change_percentage_24h
              : ""
          }
          ath={
            this.state.Data.market_data
              ? this.state.Data.market_data.ath.usd
              : ""
          }
          atl={
            this.state.Data.market_data
              ? this.state.Data.market_data.ath.usd
              : ""
          }
          sentiment={this.state.Data.sentiment_votes_up_percentage}
          high24={
            this.state.Data.market_data
              ? this.state.Data.market_data.high_24h["usd"]
              : ""
          }
          low24={
            this.state.Data.market_data
              ? this.state.Data.market_data.low_24h["usd"]
              : ""
          }
        />
        <ChartSection
          Id={this.state.Id}
          priceChange24={
            this.state.Data.market_data
              ? this.state.Data.market_data.price_change_24h_in_currency.usd
              : ""
          }
          MarketCap={
            this.state.Data.market_data
              ? this.state.Data.market_data.market_cap.usd
              : ""
          }
          TotVol={
            this.state.Data.market_data
              ? this.state.Data.market_data.total_volume.usd
              : ""
          }
          Circulating={
            this.state.Data.market_data
              ? this.state.Data.market_data["circulating_supply"]
              : ""
          }
          twitterF={
            this.state.Data.community_data
              ? this.state.Data.community_data.twitter_followers
              : ""
          }
        />
      </div>
    );
  }
}
